import React, { useState } from "react";
import Header from "../components/Header";
import "../styles/homestyle.css";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import { Card } from "react-bootstrap";

const books = [
  {
    title: ["Normal People", ""],
    genre: "Fiction",
    eventDate: "Wed, Oct 20 - 7:00 pm",
    ageGroup: "20-30 age",
    eventType: "Group event",
    image: require("../pages/image/book1.png"),
  },
  {
    title: ["Before the coffee", "gets cold"],
    genre: "Crime",
    eventDate: "Wed, Oct 20 - 7:00 pm",
    ageGroup: "20-30 age",
    eventType: "Group event",
    image: require("../pages/image/book2.png"),
  },
  {
    title: ["We Solver Murders", ""],
    genre: "Fiction",
    eventDate: "Wed, Oct 20 - 7:00 pm",
    ageGroup: "20-30 age",
    eventType: "Group event",
    image: require("../pages/image/book3.png"),
  },
  {
    title: ["Yellowface", ""],
    genre: "Fiction",
    eventDate: "Wed, Oct 20 - 7:00 pm",
    ageGroup: "20-30 age",
    eventType: "Group event",
    image: require("../pages/image/book4.png"),
  },
  {
    title: ["Abroad in Japan", ""],
    genre: "Fiction",
    eventDate: "Wed, Oct 20 - 7:00 pm",
    ageGroup: "20-30 age",
    eventType: "Group event",
    image: require("../pages/image/book5.png"),
  },

  {
    title: ["Normal People", ""],
    genre: "Fiction",
    eventDate: "Wed, Oct 20 - 7:00 pm",
    ageGroup: "20-30 age",
    eventType: "Group event",
    image: require("../pages/image/book1.png"),
  },
  {
    title: ["Before the coffee", "gets cold"],
    genre: "Crime",
    eventDate: "Wed, Oct 20 - 7:00 pm",
    ageGroup: "20-30 age",
    eventType: "Group event",
    image: require("../pages/image/book2.png"),
  },
  {
    title: ["We Solver Murders", ""],
    genre: "Fiction",
    eventDate: "Wed, Oct 20 - 7:00 pm",
    ageGroup: "20-30 age",
    eventType: "Group event",
    image: require("../pages/image/book3.png"),
  },
  {
    title: ["Yellowface", ""],
    genre: "Fiction",
    eventDate: "Wed, Oct 20 - 7:00 pm",
    ageGroup: "20-30 age",
    eventType: "Group event",
    image: require("../pages/image/book4.png"),
  },
  {
    title: ["Abroad in Japan", ""],
    genre: "Fiction",
    eventDate: "Wed, Oct 20 - 7:00 pm",
    ageGroup: "20-30 age",
    eventType: "Group event",
    image: require("../pages/image/book5.png"),
  },

  // Add more book data here as needed
];

const BooksAndReviews = () => {
 

  const [selectedMonth, setSelectedMonth] = useState(""); // State for selected month
  const [selectedGenre, setSelectedGenre] = useState(""); // State for selected genre
  const [selectedAge, setSelectedAge] = useState(""); // State for selected age group
  const [selectedType, setSelectedType] = useState(""); // State for selected age group

  // Handle month selection
  const handleMonthChange = (e) => setSelectedMonth(e.target.value);
  // Handle genre selection
  const handleGenreChange = (e) => setSelectedGenre(e.target.value);
  // Handle age selection
  const handleAgeChange = (e) => setSelectedAge(e.target.value);

  const handleTypeChange = (e) => setSelectedType(e.target.value);

  // Extract the month from the eventDate
  const getMonthFromEventDate = (date) => {
    const month = new Date(date.split("-")[0].trim()).getMonth() + 1;
    return month; // Returns a number (1 for Jan, 2 for Feb, etc.)
  };

  // Filter books based on selected month, genre, and age group
  const filteredBooks = books.filter((book) => {
    const bookMonth = getMonthFromEventDate(book.eventDate);
    const isMonthMatch = selectedMonth
      ? parseInt(selectedMonth) === bookMonth
      : true;
    const isGenreMatch = selectedGenre ? book.genre === selectedGenre : true;
    const isAgeMatch = selectedAge ? book.ageGroup === selectedAge : true;
    const isTypeMatch = selectedType ? book.eventType === selectedType : true;

    return isMonthMatch && isGenreMatch && isAgeMatch && isTypeMatch;
  });

  return (
    <>
      <Header />
      <div className="d-sm-flex  justify-content-center gap-5 ">
        <div
          className=" align--center  "
          style={{ backgroundColor: "transparent" }}
        >
          <InputGroup
            className="mt-5  outline1"
            style={{ backgroundColor: "transparent" }}
          >
            <img
              className=" mx-2 mt-2   mobilwid1 "
              src={require("../pages/image/lactionicon.png")}
              alt="logo"
            />
            <Form.Control
              className=" placeholder-1 fw600 fs-5  ftzinput"
              style={{
                backgroundColor: "transparent",

                color: "#979797",
              }}
              placeholder="Amsterdam"
              aria-label="Recipient's username"
              aria-describedby="basic-addon2"
            />
            <InputGroup.Text
              className="mobil1"
              id="basic-addon2"
              style={{
                width: "51px",
                height: "49px",
                backgroundColor: "#34C3C9",
              }}
            >
              <img
                className=" sm:w-100  mobilwid111 "
                src={require("../pages/image/searchwhite.png")}
                alt="logo"
              />
            </InputGroup.Text>
          </InputGroup>
        </div>

        <div
          className="sm:mt-5 align--center  "
          style={{ backgroundColor: "transparent" }}
        >
          <InputGroup
            className="mt-5  outline12"
            style={{ backgroundColor: "transparent" }}
          >
            <Form.Control
              className=" px-4 placeholder-1 fs-5 ftzinput"
              style={{
                backgroundColor: "transparent",

                fontFamily: "Open Sans",
                fontWeight: "600",
                lineHeight: "40px",

                color: "#979797",
              }}
              placeholder="Search book events"
              aria-label="Recipient's username"
              aria-describedby="basic-addon2"
            />
            <InputGroup.Text
              className="mobil1  py-1 px-2"
              id="basic-addon2"
              style={{
                width: "51px",
                height: "49px",

                // height: "51px",
                backgroundColor: "#34C3C9",
              }}
            >
              <img
                className="   mobilwid111 "
                src={require("../pages/image/searchwhite.png")}
                alt="logo"
              />
            </InputGroup.Text>
          </InputGroup>
        </div>
      </div>

      <div className=" mt-5 flex-wrap d-flex justify-content-center gap-3 ">
        {/* Month Selector */}
        <div
          className=""
          style={{
            width: "136px",
            height: "40px",
            backgroundColor: "#34c3c91a",
            borderRadius: "10px",
            color: "#3B3B3B",
          }}
        >
          <Form.Select
            aria-label="Select Month"
            className="outline11 px-4 pt-0 ftzcopy"
            style={{
              backgroundColor: "#34c3c91a",
              width: "120px",
              height: "40px",
              color: "#3B3B3B",
              fontSize: "18px",
              fontFamily: "Open Sans",
              fontWeight: "600",
              lineHeight: "40px",
            }}
            value={selectedMonth} // Bind the value to the selected month
            onChange={handleMonthChange} // Handle change in month selection
          >
            <option value="">Month</option>
            <option value="1">Jan</option>
            <option value="2">Feb</option>
            <option value="3">Mar</option>
            <option value="4">Apr</option>
            <option value="5">May</option>
            <option value="6">Jun</option>
            <option value="7">Jul</option>
            <option value="8">Aug</option>
            <option value="9">Sep</option>
            <option value="10">Oct</option>
            <option value="11">Nov</option>
            <option value="12">Dec</option>
          </Form.Select>
        </div>

        {/* Genre Selector */}
        <div
          className=""
          style={{
            width: "136px",
            height: "40px",
            backgroundColor: "#34c3c91a",
            borderRadius: "10px",
            color: "#3B3B3B",
          }}
        >
          <Form.Select
            aria-label="Select Genre"
            className="outline11 px-4 pt-0 ftzcopy"
            style={{
              backgroundColor: "#34c3c91a",
              width: "120px",
              height: "40px",
              color: "#3B3B3B",
              fontSize: "18px",
              fontFamily: "Open Sans",
              fontWeight: "600",
              lineHeight: "40px",
            }}
            value={selectedGenre} // Bind the value to the selected genre
            onChange={handleGenreChange} // Handle change in genre selection
          >
            <option value="">Genre</option>
            <option value="Fiction">Fiction</option>
            <option value="Crime">Crime</option>
            {/* Add more genres as needed */}
          </Form.Select>
        </div>

        <div
          className=""
          style={{
            width: "136px",
            height: "40px",
            backgroundColor: "#34c3c91a",
            borderRadius: "10px",
            color: "#3B3B3B",
          }}
        >
          <Form.Select
            aria-label="Select Age Group"
            className="outline11 px-4 pt-0 ftzcopy"
            style={{
              backgroundColor: "#34c3c91a",
              borderRadius: "10px",
              width: "120px",
              height: "40px",
              color: "#3B3B3B",
              fontSize: "18px",
              fontFamily: "Open Sans",
              fontWeight: "600",
              lineHeight: "40px",
              textAlign: "center",
            }}
            value={selectedAge} // Bind selected value
            onChange={handleAgeChange} // Handle age selection
          >
            <option value="">Age</option>
            <option value="20-30 age">20-30</option>
            <option value="30-40 age">30-40</option>
          </Form.Select>
        </div>

        {/* <div
          className=""
          style={{
            width: "136px",
            height: "40px",
            backgroundColor: "#34c3c91a",
            borderRadius: "10px",
            color: "#3B3B3B",
          }}
        >
          <Form.Select
            aria-label="Default select example"
            className="outline11 px-4 pt-0  "
            style={{
              backgroundColor: "#34c3c91a",
              borderRadius: "10px",
              width: "120px",
              height: "40px",
              color: "#3B3B3B",
              fontSize: "18px",
              fontFamily: "Open Sans",
              fontWeight: "600",
              lineHeight: "40px",
              textAlign: "center",
              
            }}
          >
            <option>Age</option>
            <option value="1">20-30</option>
            <option value="2">30-40</option>
          </Form.Select>
        </div> */}

        <div
          className=""
          style={{
            width: "136px",
            height: "40px",
            backgroundColor: "#34c3c91a",
            borderRadius: "10px",
            color: "#3B3B3B",
          }}
        >
          <Form.Select
            aria-label="Default select example"
            className="outline11 px-4 pt-0 ftzcopy "
            style={{
              backgroundColor: "#34c3c91a",
              borderRadius: "10px",
              width: "110px",
              height: "40px",
              color: "#3B3B3B",
              fontSize: "18px",
              fontFamily: "Open Sans",
              fontWeight: "600",
              lineHeight: "40px",
            }}
            value={selectedType} // Bind selected value
            onChange={handleTypeChange}
          >
            <option value="">Type</option>
            <option value="Group event">Group event</option>
            <option value="Other Group">Other</option>
          </Form.Select>
        </div>

        <div
          className=""
          style={{
            width: "136px",
            height: "40px",
            backgroundColor: "#34c3c91a",
            borderRadius: "10px",
            color: "#3B3B3B",
          }}
        >
          <Form.Select
            aria-label="Default select example"
            className="outline11 pt-0 ftzcopy "
            style={{
              backgroundColor: "#34c3c91a",
              width: "130px",
              height: "40px",
              color: "#3B3B3B",
              fontSize: "18px",
              fontFamily: "Open Sans",
              fontWeight: "600",
              lineHeight: "40px",
            }}
          >
            <option>Language </option>
            <option value="1">English</option>
            <option value="2">Japan</option>
            <option value="3">Dut h</option>
          </Form.Select>
        </div>

        <div
          className="fw-bold ftzcopy "
          style={{
            color: "#34C3C9",
            lineHeight: "40px",
            fontSize: "18px",
            cursor: "pointer",
          }}
          onClick={() => window.location.reload()}
        >
          Reset Filters
        </div>
      </div>

      <div className="d-flex justify-content-center gap-3   margn">
        <div
          className="border-1 w-100 "
          style={{
            maxWidth: "532px",
            border: "#000000",
            border: "1px solid",
            height: "1px",
          }}
        ></div>

        <div
          className="ftzcopy   fs-5 text-center"
          style={{
            color: "#595959",

            fontFamily: "Open Sans",
            fontWeight: "600",
            lineHeight: "22px",
            marginTop: "-12px",
          }}
        >
          October 2024
        </div>
        <div
          className="border-1 w-100 "
          style={{
            maxWidth: "532px",
            border: "#000000",
            border: "1px solid",
            height: "1px",
          }}
        ></div>
      </div>


      {/* Book list */}
      <div className="d-flex flex-wrap justify-content-center gap-3 mt-5">
        {filteredBooks.map((book, index) => (
          <Card
            key={index}
            className="border-0 align-items-center"
            style={{ width: "" }}
          >
            <Card.Img
              className="imgsize"
              variant="top"
              src={book.image}
              style={{ width: "195px", height: "275px" }}
            />
            <Card.Body className="pt-1  text-center">
              <Card.Title
                className="text-center w-100 ftztitle "
                style={{
                  color: "#000000",
                  fontSize: "23px",
                  fontFamily: "Open Sans",
                  fontWeight: "700",
                  lineHeight:
                    book.title[0] === "Before the coffee" ? "20px" : "40px", // Conditional line height
                }}
              >
                {book.title[0]} <br /> {book.title[1]}
              </Card.Title>
              <Card.Text
                className="text-center m-0 ftzgern fs-5"
                style={{
                  color: "#000000",

                  fontFamily: "Open Sans",
                  fontWeight: "400",
                  lineHeight: "40px",
                }}
              >
                {book.genre}
              </Card.Text>
              <Card.Text
                className="text-center w-100 ftzgern fs-5 m-0"
                style={{
                  color: "#34C3C9",

                  fontFamily: "Open Sans",
                  fontWeight: "700",
                  lineHeight: "40px",
                  maxWidth: "213px",
                }}
              >
                {book.eventDate}
              </Card.Text>
              <Card.Title
                className="text-center ftzgern fs-5 m-0"
                style={{
                  color: "#000000",

                  fontFamily: "Open Sans",
                  fontWeight: "600",
                  lineHeight: "40px",
                }}
              >
                {book.ageGroup}
              </Card.Title>
              <Card.Title
                className="text-center ftzgern fs-5 m-0"
                style={{
                  color: "#000000",

                  fontFamily: "Open Sans",
                  fontWeight: "700",
                  lineHeight: "40px",
                }}
              >
                {book.eventType}
              </Card.Title>
            </Card.Body>
          </Card>
        ))}
      </div>

      

      <div className="d-flex justify-content-center gap-3   margn">
        <div
          className="border-1 w-100 "
          style={{
            maxWidth: "532px",
            border: "#000000",
            border: "1px solid",
            height: "1px",
          }}
        ></div>

        <div
          className=" ftzcopy fs-5 text-center"
          style={{
            color: "#595959",

            fontFamily: "Open Sans",
            fontWeight: "600",
            lineHeight: "22px",
            marginTop: "-12px",
          }}
        >
          November 2024
        </div>
        <div
          className="border-1 w-100 "
          style={{
            maxWidth: "532px",
            border: "#000000",
            border: "1px solid",
            height: "1px",
          }}
        ></div>
      </div>

      {/* Book list */}
      <div className="d-flex flex-wrap justify-content-center gap-3 mt-5">
        {filteredBooks.map((book, index) => (
          <Card
            key={index}
            className="border-0 align-items-center"
            style={{ width: "" }}
          >
            <Card.Img
              className="imgsize"
              variant="top"
              src={book.image}
              style={{ width: "195px", height: "275px" }}
            />
            <Card.Body className="pt-1  text-center">
              <Card.Title
                className="text-center w-100 ftztitle "
                style={{
                  color: "#000000",
                  fontSize: "23px",
                  fontFamily: "Open Sans",
                  fontWeight: "700",
                  lineHeight:
                    book.title[0] === "Before the coffee" ? "20px" : "40px", // Conditional line height
                }}
              >
                {book.title[0]} <br /> {book.title[1]}
              </Card.Title>
              <Card.Text
                className="text-center m-0 ftzgern fs-5"
                style={{
                  color: "#000000",

                  fontFamily: "Open Sans",
                  fontWeight: "400",
                  lineHeight: "40px",
                }}
              >
                {book.genre}
              </Card.Text>
              <Card.Text
                className="text-center w-100 ftzgern fs-5 m-0"
                style={{
                  color: "#34C3C9",

                  fontFamily: "Open Sans",
                  fontWeight: "700",
                  lineHeight: "40px",
                  maxWidth: "213px",
                }}
              >
                {book.eventDate}
              </Card.Text>
              <Card.Title
                className="text-center ftzgern fs-5 m-0"
                style={{
                  color: "#000000",

                  fontFamily: "Open Sans",
                  fontWeight: "600",
                  lineHeight: "40px",
                }}
              >
                {book.ageGroup}
              </Card.Title>
              <Card.Title
                className="text-center ftzgern fs-5 m-0"
                style={{
                  color: "#000000",

                  fontFamily: "Open Sans",
                  fontWeight: "700",
                  lineHeight: "40px",
                }}
              >
                {book.eventType}
              </Card.Title>
            </Card.Body>
          </Card>
        ))}
      </div>

     
    </>
  );
};

export default BooksAndReviews;
